<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="fio-titul col-lg-4" :class="fioAnim ? 'f-anim' : ''"
          :style="'--bgColor5:' + colorRand() + ';--bgColor6:' + colorRand() + ';'" @mouseover="fioAnim = !fioAnim">
          <h1>От составителей</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">

        </div>
        <div class="col-lg-8 pt-5">
          <div>
            <p>Библиотека предоставляет массу возможностей для образования и&nbsp;интеллектуального развития, культурного
              досуга и&nbsp;релаксации в&nbsp;кругу друзей и&nbsp;близких по&nbsp;интересам. В&nbsp;библиотеку
              вы&nbsp;можете прийти, как и&nbsp;раньше, за&nbsp;книгой, но&nbsp;еще в&nbsp;ней можно интересно
              и&nbsp;разнообразно провести свое время. </p>
            <p>А&nbsp;библиотекарь сегодня&nbsp;— это профессионал своего дела, увлеченный не&nbsp;только чтением книг
              и&nbsp;организацией
              тишины в&nbsp;пространстве, но&nbsp;и&nbsp;способный внедрить на&nbsp;пользу дела цифровые технологии,
              организовать клуб для
              встреч со&nbsp;значимыми персонами региона, провести интеллектуальное мероприятие и&nbsp;многое другое.
              Сегодня
              деятельность специалиста, работающего в&nbsp;библиотеке, очень многообразна. Тем и&nbsp;интересны люди,
              работающие в&nbsp;библиотеке. Им&nbsp;нужно идти в&nbsp;ногу со&nbsp;временем, чтобы привлекать
              в&nbsp;библиотеку молодое
              поколение, и&nbsp;в&nbsp;то&nbsp;же&nbsp;время нужно сохранять культуру, языковую норму, редкие издания и
              транслировать эту информацию в&nbsp;общество.
            </p>
            <p>Коллектив Национальной библиотеки Удмуртской Республики&nbsp;— сообщество, объединенное профессиональными
              интересами и&nbsp;целями, любовью и&nbsp;уважением к&nbsp;читателям. Коллектив разнообразен, как
              разнообразна и&nbsp;сама
              Национальная библиотека Удмуртской Республики. В&nbsp;ней работают библиотекари с&nbsp;большим стажем
              и&nbsp;молодежь,
              технари и&nbsp;лирики, лидеры и&nbsp;скрупулезные исполнители. Все они важны и&nbsp;уважаемы. Каждый вносит
              свой вклад в&nbsp;успешность родной библиотеки. Сегодня мы представляем вашему вниманию только небольшую
              часть портретов
              библиотечных специалистов&nbsp;— это наш первый опыт, надеемся, что со&nbsp;временем сможем рассказать
              о&nbsp;библиотеке во&nbsp;всем ее&nbsp;многообразии.</p>
            <p>Издание подготовлено к&nbsp;очередному юбилею Национальной библиотеки Удмуртской Республики&nbsp;— 105&#8209;летию;
              является началом серии публикаций о&nbsp;сотрудниках библиотеки, внесших вклад в&nbsp;развитие библиотечной
              деятельности, в&nbsp;продвижение книги и&nbsp;чтения. Портретные очерки о&nbsp;сотрудниках Национальной библиотеки
              Удмуртской Республики написали их&nbsp;же&nbsp;коллеги, поэтому было принято решение оставить авторскую стилистику.
              Пять очерков, посвященных работникам краеведческого направления, написаны народным писателем&nbsp;УР Вячеславом
              Ар&#8209;Серги, они оставлены в&nbsp;авторской редакции. Так как некоторые сотрудники библиотеки за&nbsp;свою долгую
              профессиональную деятельность поработали в&nbsp;разных отделах, было принято решение сгруппировать тексты о&nbsp;них
              по&nbsp;виду деятельности, в&nbsp;который они трудятся на&nbsp;момент подготовки издания. Украшением издания стали
              фотографии сотрудников того периода, когда они пришли работать в&nbsp;библиотеку, и&nbsp;в&nbsp;настоящий момент. </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import videojs from 'video.js';


export default {
  metaInfo: {
    title: 'От составителей',
  },
  data() {
    return {
      family: 'Иванов',
      name: 'Иван',
      lastName: 'Иванович',
      items: {},
      scrolling: 0,
      n: 0,
      fioAnim: false,
      screenHeight: document.documentElement.clientHeight,
      // player: null
    }
  },

  mounted() {
    window.scrollTo(0,0);
    // document.title = 'От составителей';
    window.addEventListener("scroll", this.onScroll, true);
    // this.player = videojs('my-video');
    this.$watch('items', (newVal, oldVal) => {
      if (this.scrolling === 0) {
        // this.renderTrajectory();
      }
      if (oldVal !== newVal && this.items.video)
        this.resizeVideo();

    })

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
  methods: {
    zoom(index) {
      if (!this.$refs.imgRef[index].classList.contains('zoomed')) {
        this.$refs.imgRef[index].classList.add("zoomed");
      } else {
        this.$refs.imgRef[index].classList.remove("zoomed");
      }
    },
    colorRand() {
      // return '#' + (Math.floor(Math.random() * (6710886 - 2236962 + 1) + 2236962)).toString(16);
      return '#' + (Math.floor(Math.random() * (16777215 - 1048576 + 1) + 1048576)).toString(16);
    },
    getJSON() {
      fetch('/' + this.$route.params.persona + '/' + this.$route.params.persona + '.json')
        .then((res) => res.json())
        .then((items) => {
          this.items = items


          // this.countImages()
        })
    },
    onScroll(e) {
      this.scrolling = Math.round(e.target.documentElement.scrollTop);
      // console.log(this.$refs.imgRef[0].parentElement.offsetTop);
      // this.renderTrajectory();
    },
    renderTrajectory() {
      if (this.$refs.imgRef && this.$refs.imgRef.length > 0) {
        for (let i = 0; i < this.$refs.imgRef.length ?? 0; i++) {
          // + ' | ' + Math.round(e.target.documentElement.scrollTop)  
          // + ' | ' + this.$refs.imgRef[i].parentElement.offsetTop
          // + ' | ' + this.$refs.imgRef[i].parentElement.offsetHeight
          // + ' | ' + Math.round(e.target.documentElement.scrollTop) + this.screenHeight
          // );
          // console.log(this.screenHeight);
          if (
            (this.scrolling <= this.$refs.imgRef[i].parentElement.offsetTop &&
              this.scrolling + this.screenHeight > this.$refs.imgRef[i].parentElement.offsetTop) ||
            (this.scrolling <= this.$refs.imgRef[i].parentElement.offsetTop + this.$refs.imgRef[i].parentElement.offsetHeight &&
              this.scrolling + this.screenHeight > this.$refs.imgRef[i].parentElement.offsetTop + this.$refs.imgRef[i].parentElement.offsetHeight)
          ) {
            if (this.$refs.imgRef[i].classList.contains('first-position')) {
              this.$refs.imgRef[i].style.marginTop = ((this.scrolling + this.screenHeight - this.$refs.imgRef[i].parentElement.offsetTop - (this.$refs.imgRef[i].parentElement.offsetHeight / 4)) / 4) + 'px';
              // if (i == 3)
              // console.log(i);
            }
            if (this.$refs.imgRef[i].classList.contains('third-position')) {
              this.$refs.imgRef[i].style.marginTop = 300 - ((this.scrolling + this.screenHeight - this.$refs.imgRef[i].parentElement.offsetTop - (this.$refs.imgRef[i].parentElement.offsetHeight / 4)) / 4) + 'px';
              // console.log(i);
            }
            // console.log(i);
          }
        }
      }
    },
    resizeVideo() {
      // console.log("111111" + this.$refs.videoRef.offsetWidth);
      if (this.$refs.videoRef)
        this.$refs.videoRef.style.height = ((this.$refs.videoRef.offsetWidth / 16) * 9) + 'px';
    }
    // play() {
    //   this.player.play();
    // },
    // pause() {
    //   this.player.pause();
    // },
    // stop() {
    //   this.player.reset();
    // }
  }
}
</script>

<style>
.fio-titul h1 {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
  font-size: calc((100vw - 480px)/(1280 - 480) * (100 - 60) + 60px);
  text-align: left;
  left: 0;
}

p {
  text-align: left;
  font-size: 20px;
  color: black;
}

.fio-titul {
  background: linear-gradient(to top right, var(--bgColor5) 0%, var(--bgColor6) 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: table;
}

h2 {
  font-family: 'Pattaya';
  font-weight: normal;
  font-style: normal;
  text-align: left;
  font-size: calc((100vw - 480px)/(1280 - 480) * (50 - 30) + 30px);
}

.zoomed img {
  position: fixed;
  background-color: black;
  width: 100%;
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
  top: 0;
  left: 0;
  transition: .5s;
  cursor: zoom-out;
  object-fit: contain !important;
  object-position: center !important;
  display: block;
  z-index: 999;
  max-width: 100%;
  max-height: 100%;
}

.plus-circle.zoom {
  cursor: zoom-in;
}

a img {
  text-align: left;
  /* left: 0; */
  float: left;
}

.experience-text {
  display: inline-block;
  width: 120px;
  vertical-align: top;
  font-size: 20px;
}

.post-text {
  display: inline-block;
  width: 120px;
  vertical-align: top;
  font-size: 20px;
}

.post {
  display: inline-block;
  width: calc(100% - 140px);
}

.post span {
  font-size: 20px;
}

.experience {
  position: relative;
  display: inline-block;
  width: calc(100% - 140px);
}

.experience-big-star {
  position: absolute;
  z-index: 1;
  width: 100%;
  display: block;
  top: -20px;
  opacity: 0;
  transition: .5s;
}

.experience-big-star:hover {
  opacity: 1;
}

.experience-star {
  position: absolute;
  /* left: 20px; */
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}

.experience-years {
  position: absolute;
  top: 22px;
  /* left: 22px; */
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  font-size: 30px;
  z-index: 2;
}
</style>
